import { render, staticRenderFns } from "./xmpq.vue?vue&type=template&id=2ed9192a&scoped=true&"
import script from "./xmpq.vue?vue&type=script&lang=js&"
export * from "./xmpq.vue?vue&type=script&lang=js&"
import style0 from "./xmpq.vue?vue&type=style&index=0&id=2ed9192a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed9192a",
  null
  
)

export default component.exports